<template>
  <v-layout row wrap>
    <v-flex md12>
      <v-list>
        <draggable
          v-model="queue_patient_details"
          :options="{disable:false,draggable:'.item',group:'lists'}"
          class="minhgt"
          @end="changeAppointmentPosition"
          id="3"
          :move="onMove"
        >
          <div v-for="Queuelist in queue_patient_details">{{Queuelist.id}}</div>
          <!-- <div v-for="Queuelist in queue_patient_details" class="item"> -->

          <!-- <Patient :name="Queuelist.name" :gender="Queuelist.gender" :age="Queuelist.age" :city="Queuelist.place" :lastVisit="Queuelist.previous_appointment" :id="Queuelist.id" :order="Queuelist.order" @click="test" /> -->
          <!-- </div> -->
        </draggable>
      </v-list>
    </v-flex>
  </v-layout>
</template>
<script>
import $ from "jquery";
import Header from "./Header";
import Patient from "./Patient";
// import { store } from '../store';
import draggable from "vuedraggable";
import { mapState, mapActions, mapMutations } from "vuex";
// import WaitingList from './WaitingList';

export default {
  name: "PatientList",
  components: {
    Patient,
    draggable,
    Header
    // WaitingList
  },
  data() {
    return {
      // result:[],
    };
  },
  computed: {
    queue_patient_details: {
      get() {
        return this.$store.state.queue_patient_details[0][0].info;
      },
      set(value) {
        this.$store.commit("update_patient_list", value);
      }
    }
    // })
  },

  methods: {
    test() {
      alert();
    },
    ...mapActions(["getdata", "changeAppointmentPosition"]),
    ...mapMutations(["onEnd"]),
    // onEnd(evt) {
    //   console.log(evt.from.id);
    //   console.log(evt.to.id);
    //   console.log(evt.oldIndex + 1);
    //   console.log(evt.newIndex + 1);
    //   },
    // 1=Waiting
    // 2=completed
    // 3=queue
    onMove(evt) {
      console.log(evt.to.id);
      // console.log(evt.from.id)
      if (evt.to.id == "2") {
        return false;
      } else if (evt.to.id == "3") {
        return false;
      } else {
        return true;
      }
    }
  },

  beforeMount() {
    this.getdata();
  }
};
</script>
<style scoped>
.item {
  border-bottom: 0.5px solid #e0e0e0;
  padding: 0.5rem 0rem;
  /* -webkit-box-shadow: 0px 0.5px 1px 1px rgba(0,0,0,0.31); */
  /* -moz-box-shadow: 0px 0.5px 1px 1px rgba(0,0,0,0.31); */
  /* box-shadow: 0px 0.5px 1px 1px rgba(0,0,0,0.31); */
}

.patient_details {
  display: flex;
  justify-content: space-around;
}

.minhgt {
  min-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/PatientList.vue